import { useInView } from 'react-intersection-observer';

//components
import {
  Section,
  Kicker,
  KickerDot,
  SectionTitle,
  SectionLede,
  Grad,
} from '@/containers-ai/SectionHeading';
import { PillLink } from '@/containers-ai/Buttons';

//styles
import {
  AIGrid,
  CtaRow,
  Panel,
  ClimbHeading,
  Bars,
  Bar,
  QuarterRow,
  Quarter,
  ClimbFooter,
} from './AICompounding.styles';
import { Container } from '@/components/Grid';

const bars = [
  { quarter: 'Q1', height: '46%' },
  { quarter: 'Q2', height: '64%' },
  { quarter: 'Q3', height: '82%' },
  { quarter: 'Q4', height: '98%' },
];

export function AICompounding() {
  const { ref, inView } = useInView({ threshold: 0.5, triggerOnce: true });

  return (
    <Section id="ai">
      <Container>
        <AIGrid>
          <div>
            <Kicker>
              <KickerDot />
              Powered by Loadsmart AI
            </Kicker>
            <SectionTitle style={{ maxWidth: '565px' }}>
              The more Loadsmart AI runs your freight,{' '}
              <Grad>the more it resolves on its own.</Grad>
            </SectionTitle>
            <SectionLede>
              Loadsmart AI senses, decides and acts on every load, then writes
              the outcome back into your system of record. It compounds on your
              own outcomes so it resolves more on its own over time.
            </SectionLede>
            <CtaRow>
              <PillLink href="/ai/" className="qlf-btn-8">
                Explore Loadsmart AI &#8594;
              </PillLink>
            </CtaRow>
          </div>

          <Panel ref={ref}>
            <ClimbHeading>
              Auto-resolution &#8593; quarter over quarter
            </ClimbHeading>
            <Bars>
              {bars.map((bar) => (
                <Bar key={bar.quarter} $on={inView} $height={bar.height} />
              ))}
            </Bars>
            <QuarterRow>
              {bars.map((bar) => (
                <Quarter key={bar.quarter}>{bar.quarter}</Quarter>
              ))}
            </QuarterRow>
            <ClimbFooter>
              <span>80%</span>
              <Grad style={{ fontSize: '16px' }}>95%+</Grad>
            </ClimbFooter>
          </Panel>
        </AIGrid>
      </Container>
    </Section>
  );
}
